/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetricTypeAppleHealth
 */
export interface MetricTypeAppleHealth {
    /**
     * 
     * @type {string}
     * @memberof MetricTypeAppleHealth
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MetricTypeAppleHealth
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof MetricTypeAppleHealth
     */
    metric_type?: string;
}

/**
 * Check if a given object implements the MetricTypeAppleHealth interface.
 */
export function instanceOfMetricTypeAppleHealth(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MetricTypeAppleHealthFromJSON(json: any): MetricTypeAppleHealth {
    return MetricTypeAppleHealthFromJSONTyped(json, false);
}

export function MetricTypeAppleHealthFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricTypeAppleHealth {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
        'metric_type': !exists(json, 'metric_type') ? undefined : json['metric_type'],
    };
}

export function MetricTypeAppleHealthToJSON(value?: MetricTypeAppleHealth | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'unit': value.unit,
        'metric_type': value.metric_type,
    };
}

